<!--
  @description: 组织架构 - 组织管理 - 角色权限
  @creator: lwd
  @date: 2021/03/15
-->
<template>
  <div class="role">
    <div class="role-back1 common-bg">
      <div v-if="$route.query.back">
        <IviewButton cusType="secondary" @click="back">
          <Icon type="ios-arrow-back" />
          返回
        </IviewButton>
      </div>
      <div class="org-name">{{ config.orgName }}</div>
    </div>
    <div class="role-query common-bg">
      <IviewInput label="角色名称:" v-model="queryForm.name" placeholder="请输入角色名称"></IviewInput>
      <IviewInput class="ipt2" label="用户名称:" v-model="queryForm.userDisplayName" placeholder="请输入角色名称"></IviewInput>
      <div class="query-btn">
        <IviewButton type="primary" @click="query">搜索</IviewButton>
        <IviewButton @click="reset">重置</IviewButton>
      </div>
    </div>
    <!-- S 组织架构表格 -->
    <div class="common-bg om_table">
      <div class="op_table_action" v-if="$permission('roleM-add')">
        <IviewButton type="primary" @click="addRole">
          <Icon type="md-add" />
          添加
        </IviewButton>
      </div>
      <div class="op_table_box">
        <IviewTable :data="tableData" :columns="tableCol" :page="pager" @on-page-change="changePageSize"></IviewTable>
      </div>
    </div>
    <!-- E 组织架构表格 -->

    <!-- 添加编辑角色 -->
    <addRoleUser v-model="rolePopup" :config="config" :data="currentTableData" :ppType="ppType" @refresh="getList" />

    <!-- 设置用户 -->

    <setUser v-model="userPopup" :confObj="config" @confirm="setUserConfirm" ref="setUser" />

    <!-- 删除确认框 -->
    <IviewModal title="提示" type="confirm" v-model="delPopup" confirmText2="是否继续进行删除部门操作？" @on-ok="delConfirm"
      @on-cancel="delPopup = false">
    </IviewModal>
    <!--  -->
  </div>
</template>
<script>
import { cols, textBtns } from '_u/table'
import addRoleUser from './addRoleUser.vue'
import setUser from './setUser.vue'
import { getUserInfo } from '@/utils/common'
export default {
  name: 'role-permissions',
  components: { addRoleUser, setUser },
  // inject: ['config'],
  data() {
    return {
      queryForm: {
        name: '',
        userDisplayName: ''
      },
      config: {}, //组织机构带过来的角色管理所需的数据,从localStorage 中获取
      tableCol: [
        { title: '角色名称', key: 'name', align: 'center' },
        { title: '用户', key: 'userDisplayName', tooltip: true, align: 'center' },
        ...cols([
          [
            '管理范围',
            'roleType',
            {
              render: (h, { row }) => {
                let str = ''
                if (row.manageRange === 0) str = '仅本人'
                if (row.manageRange === 1) str = '特定部门'
                if (row.manageRange === 2) str = '归属部门和下级部门'
                if (row.manageRange === 3) str = '全组织'
                if (row.manageRange === 4) str = '归属部门'
                return h('span', {}, str)
              }
            }
          ],
          [
            '类型',
            'roleType',
            {
              render: (h, { row }) => {
                let str = row.roleType == 1 ? '自定义' : '默认'
                return h('span', {}, str)
              }
            }
          ],
          ['操作时间', 'lastUpdateTime'],
          [
            '操作',
            'action',
            {
              width: 300,
              render: (h, p) => {
                let { row } = p
                let arr =
                  row.roleType == 1
                    ? [
                      this.$permission('roleM-edit') && '编辑',
                      this.$permission('roleM-put') && '设置用户',
                      this.$permission('roleM-del') && {
                        label: '删除',
                        value: 2,
                        options: { style: { color: '#B8321A' } }
                      }
                    ]
                    : this.$permission('roleM-put') && ['设置用户']
                return textBtns(h, arr, (index, item) => {
                  this.handleClickEdit(item, p.row)
                })
              }
            }
          ]
        ])
      ],
      currentTableData: {},
      id: '',
      hierachyId: '',
      ppType: 'add',
      tableData: [],
      rolePopup: false,
      userPopup: false,
      delPopup: false,
      pager: {
        current: 1,
        total: 0,
        pageSize: 10
      } // 表格页码
    }
  },
  created() {
    this.init()
  },
  mounted() {
    //如果需要在外部控制返回按钮,请在主应用传isBack:true
    // if (this.$root.isBack) {
    //   actions.setGlobalState({ showBackBtn: true })
    // }
    // actions.onGlobalStateChange((state) => {
    //   if (!state.showBackBtn) this.handleBack()
    // })
  },
  methods: {
    init() {
      // 进入方式
      //组织树进入
      if (this.$route.query.back) {
        let data = localStorage.getItem('roleConfig')
        this.config = JSON.parse(data)
        let path = this.config.path
        if (path) {
          this.config.orgName = path.slice(-path.length - 1)
        }
        this.getList()
      } else {
        //直接进入
        this.$api.config.getOrganSelect().then(async (res) => {
          let data = res.data.find((item) => item.defaultGroup == 1)
          if (data) {
            this.config = {
              id: data.groupId,
              groupId: data.groupId,
              orgLevel: data.orgLevel
            }
            let { currentGroup } = await getUserInfo()
            let path = currentGroup.path
            if (path) {
              let arr = path.split('/')
              this.config.orgName = arr.slice(1, arr.length).join('/')
            }
            localStorage.setItem('roleConfig', JSON.stringify(this.config))
            this.getList()
          } else {
            this.$Message.warning('请选择默认组织')
            this.$router.push({ path: this.$route.fullPath, query: { comp: 'app' } })
          }
        })
      }
    },
    back() {
      this.$router.back()
    },
    getList(params = {}) {
      let id = this.config.id
      this.$api.role.getRoleList({
        pageSize: this.pager.pageSize,
        pageNum: this.pager.current,
        ...params
      }, [id]).then(async ({ data }) => {
        this.tableData = data.records
        this.pager.total = data.total
      })
    },
    query() {
      this.pager.current = 1;
      this.getList(this.queryForm)
    },
    reset() {
      this.pager.current = 1;
      this.queryForm = {}
      this.getList()
    },
    // 设置用户确认 bool是否清空用户
    setUserConfirm(data, bool = true) {
      let params = {
        roleUserList: data.roleUserList.map((item) => ({
          roleId: this.id,
          userId: item.id,
          userDisplayName: item.displayName,
          groupId: this.config.id
        })),
        groupUserList: data.groupUserList
      }
      if (data.roleUserList.length > 0) {
        this.$api.role.setRole2(params).then((res) => {
          this.$Message.success('操作成功')
          this.userPopup = false
          this.getList()
        })
      } else {
        if (bool) {
          this.$api.role.clearRole2(params, [this.id]).then((res) => {
            this.$Message.success('操作成功')
            this.userPopup = false
            this.getList()
          })
        }
      }
    },
    // 点击添加按钮
    addRole() {
      this.ppType = 'add'
      this.rolePopup = true
    },
    changePageSize(e) {
      this.pager = {
        ...this.pager,
        ...e
      }
      // pageSize,pageNum
      this.getList(e)
    },
    handleClickEdit(item, row) {
      this.id = row.id
      this.hierachyId = row.hierachyId
      let { label } = item
      if (label === '编辑') {
        this.ppType = 'edit'
        this.currentTableData = { ...row }
        this.rolePopup = true
      } else if (label === '删除') {
        this.delPopup = true
      } else if (label === '设置用户') {
        this.userPopup = true
        this.$refs.setUser.getUser()
        this.$refs.setUser.getRoleUser([this.hierachyId, this.id])
      }
    },
    delConfirm() {
      this.$api.role.delRole({}, [this.hierachyId, this.id]).then((res) => {
        this.delPopup = false
        this.$Message.success('操作成功')
        this.getList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.role-back1 {
  padding: 12px 20px !important;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  .org-name {
    margin-left: 20px;
    font-size: 20px;
    font-family: Helvetica;
    color: #333333;
  }
}

.role-query {
  background: #fff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  .ipt2 {
    margin-left: 30px;
  }

  .query-btn {
    margin-left: 30px;
  }
}
</style>

<style lang="less">
.tool_tip {}

/deep/.ivu-tooltip-inner {
  min-height: 30px !important;
}

.org_manage_status {
  display: flex;
  justify-content: center;

  .bgbox {
    margin-right: 5px;
    width: 20px;
    height: 20px;

    &.stop {
      background: url(~_img/common/statu-stop.png) center center no-repeat;
      background-size: contain;
      color: #b8321a;
    }

    &.start {
      background: url(~_img/common/statu-start.png) center center no-repeat;
      background-size: contain;
      color: #1ab8a5;
    }
  }

  .text_stop {
    font-size: 14px;
    font-weight: 400;
    color: #b8321a;
  }

  .text_start {
    font-size: 14px;
    font-weight: 400;
    color: #1ab8a5;
  }
}
</style>

<style lang="less" scoped>
.role {
  width: 100%;
  height: 100%;

  .back {
    position: absolute;
    left: 200px;
    top: 20px;
  }

  .om_table {
    width: 100%;
    padding: 20px;
    height: calc(100vh - 340px);

    .op_table_action {
      margin-bottom: 10px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .op_table_box {
      width: 100%;

      /deep/.ivu-table-wrapper {
        height: calc(100vh - 450px);
      }

      /deep/.i-page {
        bottom: -40px;
      }
    }
  }
}
</style>
